export default {"src":"/_next/static/image/public/images/ic_package_white_vertical_menu.536c203e0006677b0b7be5f58a50dc7d.svg","height":20,"width":20};